import { render, staticRenderFns } from "./ChangeLogRoot.vue?vue&type=template&id=f6709766"
import script from "./ChangeLogRoot.vue?vue&type=script&lang=ts"
export * from "./ChangeLogRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports